import React, { useContext, useState } from "react";

import AuthContext from "../../context/AuthContext";

import Button from "../../components/ui/Button";
import FlexRowReverse from "../../components/ui/FlexRowReverse";
import Container from "../../components/ui/Container";
import Waleed from "../../components/svgs/Waleed";
import YearsBooks from "../../components/svgs/YearsBooks";
import Shapes from "../../components/svgs/Shapes";
import Waves from "../../components/ui/Waves";

import bg from "../../assets/bg-star.png";
import bggradient from "../../assets/bg-gradient.svg";
import profile from "../../assets/Updated-imagery/waleedHero.png";
import logolarge from "../../assets/navbar/logolight.png";

import { ReactComponent as RaiseHandIcon } from "../../assets/Updated-imagery/raiseHandCtaIcon.svg";
import { ReactComponent as BooksIcon } from "../../assets/Updated-imagery/booksCtaIcon.svg";

const MainSection = ({ title = false }) => {
    const { token } = useContext(AuthContext);

    return (
        <>
            {/*  */}
            <section className="md:h-screen min-h-screen negative-nav-margin relative overflow-hidden mb-20">
                {/* <div
                    className="inset-0 w-full h-full z-0 absolute opacity-100"
                    style={{
                        backgroundImage: "url(" + bggradient + ")",
                        backgroundSize: "cover",
                        backgroundPosition: "center center",
                    }}
                ></div>
                <div
                    className="inset-0 w-full h-full z-0 absolute opacity-10"
                    style={{
                        backgroundImage: "url(" + bg + ")",
                        backgroundSize: "cover",
                        backgroundPosition: "center center",
                    }}
                ></div> */}
                <Container className="h-full relative z-10 font-graph pt-32 md:pt-0 pb-20 md:pb-0">
                    <div className="w-full flex md:flex-row flex-col-reverse h-full space-y-20 space-y-reverse md:space-y-0">
                        <div className=" md:basis-1/2 basis-full h-full flex-center-both">
                            <div className="flex justify-center md:items-start items-center flex-col clr-white smooth space-y-6 md:space-y-8">
                                <h1 className="font-bigmax font-w-bold relative max-w-md">
                                    <img
                                        src={logolarge}
                                        alt="logo"
                                        className="dark:invert dark:brightness-100 smooth"
                                    />
                                </h1>
                                <div className="space-y-2 font-ibm flex flex-col md:items-start items-center justify-center">
                                    <h2 className="text-4xl  text-gray-600 dark:text-gray-200 smooth font-w-bold">
                                        هنا تبدأ حكايتك{" "}
                                        <span className="text-tomato-400">مع اللغة... </span>
                                    </h2>
                                    <div className="text-4xl relative text-gray-600 dark:text-gray-200 smooth">
                                        فهمًا، <span className="text-secYellow-400">تفوقًا،</span>{" "}
                                        ونجاحًا{" "}
                                    </div>
                                </div>
                                <div className="flex space-x-2 space-x-reverse w-full">
                                    <Button
                                        className="w-full block font-semibold bg-tomato-400 py-2 relative z-10 border-none scale flex-center-both gap-2 max-w-[250px]"
                                        element="Link"
                                        to={token ? "/me/user/courses" : "/register"}
                                    >
                                        <RaiseHandIcon className="inline-block w-6 h-6 ml-2" />
                                        {!token ? "انضم لينا !" : "كورساتي"}
                                    </Button>

                                    <Button
                                        className="w-full block font-semibold bg-tomato-100 text-tomato-900 dark:bg-secYellow-500 smooth py-2 relative z-10 border-none scale flex-center-both gap-2 max-w-[250px]"
                                        element="a"
                                        href="https://booxtore.net"
                                    >
                                        <BooksIcon className="inline-block w-6 h-6 ml-2" />
                                        أشتري كتابك
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="md:basis-1/2 basis-full h-full flex-center-both">
                            <div className="w-full h-full flex-center-both max-w-4xl">
                                <img src={profile} alt={"profile"} className="" />
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </>
    );
};

export default MainSection;
